import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography, Stack } from '@mui/material';
import { CalendarMonth } from '@mui/icons-material';

export default function BientotDisponible() {
    return (
        <Box sx={{
            backgroundColor: '#fff',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }}>
            <Helmet>
                <title>Version web bientôt disponible | Student Link</title>
                <meta name="description" content="La version web de Student Link sera disponible le 13 novembre 2025. En attendant, téléchargez notre application mobile." />
            </Helmet>

            {/* Header avec logo */}
            <Box sx={{
                p: 3,
                borderBottom: '1px solid #e0e0e0'
            }}>
                <Container maxWidth="lg">
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <img src="/assets/images/logo.png" alt="Student Link Logo" style={{ height: 40, marginRight: 12, borderRadius: '20%' }} />
                        <Typography component="div" sx={{
                            color: 'black',
                            fontFamily: '"Lilita One Local", "Lilita One", cursive',
                            fontSize: '1.75rem',
                            lineHeight: 1,
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            Student Link
                        </Typography>
                    </Box>
                </Container>
            </Box>

            {/* Contenu principal centré */}
            <Box sx={{
                flexGrow: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                py: 6
            }}>
                <Container maxWidth="md">
                    <Box sx={{ textAlign: 'center' }}>
                        {/* Titre principal - Focus sur l'app mobile */}
                        <Typography
                            variant="h2"
                            component="h1"
                            sx={{
                                fontWeight: 700,
                                lineHeight: 1.2,
                                fontSize: { xs: 38, md: 52 },
                                mb: 2
                            }}
                        >
                            Télécharge Student Link
                        </Typography>

                        {/* Sous-titre accrocheur */}
                        <Typography
                            variant="h5"
                            sx={{
                                color: 'text.primary',
                                fontWeight: 500,
                                mb: 4,
                                fontSize: { xs: 18, md: 22 }
                            }}
                        >
                            Trouve ton stage, alternance ou emploi en quelques clics
                        </Typography>

                        {/* Logos des stores cliquables - Plus grands et mis en avant */}
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={3}
                            justifyContent="center"
                            alignItems="center"
                            sx={{ mb: 5 }}
                        >
                            <a
                                href="https://apps.apple.com/fr/app/student-link/id6447442323"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none' }}
                            >
                                <Box
                                    component="img"
                                    src="/assets/images/app-store.png"
                                    alt="Télécharger dans l'App Store"
                                    loading="lazy"
                                    decoding="async"
                                    sx={{
                                        height: 64,
                                        width: 'auto',
                                        transition: 'transform 0.2s ease',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            transform: 'scale(1.08)'
                                        }
                                    }}
                                />
                            </a>
                            <a
                                href="https://play.google.com/store/search?q=student%20link&c=apps"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none' }}
                            >
                                <Box
                                    component="img"
                                    src="/assets/images/google-play.png"
                                    alt="Disponible sur Google Play"
                                    loading="lazy"
                                    decoding="async"
                                    sx={{
                                        height: 64,
                                        width: 'auto',
                                        transition: 'transform 0.2s ease',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            transform: 'scale(1.08)'
                                        }
                                    }}
                                />
                            </a>
                        </Stack>

                        {/* Séparateur visuel */}
                        <Box sx={{
                            width: 60,
                            height: 2,
                            backgroundColor: 'divider',
                            mx: 'auto',
                            mb: 4
                        }} />

                        {/* Info version web - En plus discret */}
                        <Box sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 1.5,
                            p: 2,
                            borderRadius: 3,
                            backgroundColor: '#f5f7fb',
                            border: '1px solid #e0e5ec',
                            mb: 2
                        }}>
                            <CalendarMonth sx={{ fontSize: 24, color: 'primary.main' }} />
                            <Typography
                                variant="body2"
                                sx={{
                                    color: 'text.secondary',
                                    fontWeight: 500,
                                    fontSize: { xs: 13, md: 14 }
                                }}
                            >
                                Version web disponible à partir du <strong style={{ color: '#0075FF' }}>13 novembre 2025</strong>
                            </Typography>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
}
